import { LOCALES } from '../locales';

export default {
  [LOCALES.GERMAN]: {
    "L'Oreal Paris Revitalift Crystal Micro-Essence Face Serum 22 ml":
      "L'Oreal Paris Revitalift Kristall Mikro-Essenz Gesichtsserum 22 ml",
    'DressBerry Women Peach-Coloured Solid Flats':
      'DressBerry Women Pfirsichfarbene feste Wohnungen',
    'ZAPATOZ Women White Sneakers': 'ZAPATOZ Damen Weiße Turnschuhe',
    'Crocs Unisex Navy Blue Solid Bayaband Clogs':
      'Crocs Unisex Marineblau Solid Bayaband Clogs',
    'SASSAFRAS Black & Pink Printed Wrap Dress':
      'SASSAFRAS Schwarz & Pink bedrucktes Wickelkleid',
    'Tokyo Talkies Navy Polka Dot Belted Shirt Dress':
      'Tokyo Talkies Navy Polka Dot Hemdkleid mit Gürtel',
    'SASSAFRAS Women Maroon Solid Tiered Maxi Dress':
      'SASSAFRAS Damen Maroon Solid Tiered Maxikleid',
    'Daniel Klein Premium Women Silver-Toned Dial Watch DK11138-2s':
      'Daniel Klein Premium Damen Silber getönte Zifferblattuhr DK11138-2s',
    'MANGO Burgundy Solid Tote Bag': 'MANGO Burgund Solid Einkaufstasche',
    HOME: 'ZUHAUSE',
    Filter: 'Filter',
    Filters: 'Filter',
    Category: 'Kategorie',
    Categories: 'Kategorie',
    'Search Products': 'Produktsuche',
    'E-mail': 'Email',
    'Sign-in': 'Einloggen',
    Password: 'Passwort',
    'Create your account': 'Erstelle deinen Account',
    'or sign-in with:': 'oder melden Sie sich an mit:',
    Google: 'Google',
    Facebook: 'Facebook',
    Phone: 'Telefon',
    'Hello, Guest': 'Hallo Gast',
    'SHOP NOW': 'JETZT EINKAUFEN',
    'PARTY WEAR': 'PARTY TRAGEN',
    'CASUAL WEAR': 'FREIZEITKLEIDUNG',
    ACCESSORIES: 'ZUBEHÖR',
    FOOTWEAR: 'SCHUHWERK',
    'Redefine your fashion with these stunning casual wear':
      'Definieren Sie Ihre Mode mit dieser atemberaubenden Freizeitkleidung neu',
    'Sophesticated accessories to make your look and life a paradise.':
      'Anspruchsvolle Accessoires machen Ihren Look und Ihr Leben zu einem Paradies.',
    'Footwear that makes you comfortable and look good.':
      'Schuhe, die Sie bequem machen und gut aussehen.',
    'Dress up for parties with the spirit of passion':
      'Dress up für Partys mit dem Geist der Leidenschaft',
    German: 'Deutsche',
    French: 'Französisch',
    English: 'Englisch',
    'Learn More': `Erfahren Sie mehr`,
    'Classic Collection 2021': 'Klassische Kollektion 2021',
    'COLLECTION 2021': 'SAMMLUNG 2021',
    'Fresh Collection 2021': 'Frische Sammlung 2021',
    'Fashion Collection 2021': 'Modekollektion 2021',
    Login: 'Anmeldung',
    Account: 'Konto',
    Orders: 'Aufträge',
    'Featured Products': 'Ausgewählte Produkte',
    'Recommended for you': 'Für dich empfohlen',
    'Tinny Three Quarter Sleeve Dress': 'Dünnes Dreiviertel-Ärmelkleid',
    'Vila Striped T-Shirt Dress': 'Vila gestreiftes T-Shirt Kleid',
    'Sleeveless Deana Maxi Dress': 'Ärmelloses Deana Maxikleid',
    About: 'Über',
    Services: 'Dienstleistungen',
    Portfolio: 'Portfolio',
    Pricing: 'Preisgestaltung',
    Customers: 'Kunden',
    Careers: 'Karriere',
    Resources: 'Ressourcen',
    Docs: 'Docs',
    Blog: 'Blog',
    eBooks: 'eBooks',
    Contact: 'Kontakt',
    Help: 'Hilfe',
    Sales: 'Der Umsatz',
    Advertise: 'Werben',
    Webinars: 'Webinare',
    Subscribe: 'Abonnieren',
    'Stay Updated': 'Bleiben Sie auf dem Laufenden',
    'Subscribe to our newsletter to get our latest news':
      'Abonnieren Sie unseren Newsletter, um unsere neuesten Nachrichten zu erhalten',
    'Enter email address': 'E-Mail Adresse eingeben',
    'Terms & Conditions': 'Terms & Bedingungen',
    'Privacy Policy': 'Datenschutz-Bestimmungen',
    Copyright: 'Urheberrechte ',
  },
};
